import Vue from 'vue'
const sdk = {};


export default sdk

sdk.status = {
  topic: null
};

sdk.getCurrency = (id) => {
  return new Promise((resolve, reject) => {
    Vue.http({
      url: "/api",
      method: "GET",
    }).then(response => {
      resolve(response.data)
    });
  });
}


// WEBPACK FOOTER //
// ./src/lib/sdk.js